module.exports = __webpack_public_path__ + "static/media/ig.7b5dfa68.svg";